import angular from 'angular';

const module = angular.module('whyline.directives.minMaxValue', []);

const minMaxValue = () => ({
  link: (scope, element, attributes) => {
    element.on('keydown keyup keypress', function(e) {
      if (
        parseInt(element.val()) > parseInt(attributes.max)
        && e.keyCode != 46
        && e.keyCode != 8
      ) {
        e.preventDefault();
        element.val(attributes.max);
      }
      if (
        parseInt(element.val()) < parseInt(attributes.min)
        && e.keyCode != 46
        && e.keyCode != 8
      ) {
        e.preventDefault();
        element.val(attributes.min);
      }
    });
  },
});

module.exports = module.directive('minMaxValue', minMaxValue);
